import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { api } from '../../api';
import { Gate } from '../../schema/gate';

interface GateFromInputProps {
  required?: boolean;
  value?: number | null;
  gateIds?: number[];
  onChange?: (value: number | null) => void;
}

const GateFromInput: React.FC<GateFromInputProps> = ({
  required,
  value,
  gateIds,
  onChange
}: GateFromInputProps) => {
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [gateList, setGateList] = useState<Gate[]>([]);
  const [selectedValue, setSelectedValue] = useState<Gate | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  // ใช้ตัดผลลัพธ์ของ request เก่าที่ตอบกลับมาช้ากว่า request ล่าสุด
  const requestIdRef = useRef(0);

  const fetchGateList = (keyword?: string) => {
    const requestId = ++requestIdRef.current;
    const searchParams = new URLSearchParams();
    gateIds?.forEach((gate_id) => {
      searchParams.append('id', `${gate_id}`);
    });
    searchParams.set('not_inid', 'true');
    if (keyword) {
      searchParams.set('name', keyword);
    }
    // searchParams.set('limit', '10');
    setLoading(true);
    api
      .get<Gate[]>(`/gate`, { params: searchParams })
      .then((res) => {
        if (requestId !== requestIdRef.current) return;
        setGateList(res.data);
      })
      .finally(() => {
        if (requestId === requestIdRef.current) setLoading(false);
      });
  };

  useEffect(() => {
    if (value != null) {
      const gate = gateList.find((data) => data.id == value);
      if (gate) {
        setSelectedValue(gate);
        return;
      }
      api.get<Gate>(`/gate/${value}`).then((res) => {
        const { data } = res;
        setSelectedValue(data);
        setGateList([data]);
      });
    } else {
      fetchGateList();
      setSelectedValue(null);
    }
  }, [value]);

  useEffect(() => {
    if (searchKeyword) {
      // ล้างรายการเดิมทันที ไม่ให้แสดงผลของคำค้นก่อนหน้าระหว่างรอ debounce
      requestIdRef.current++;
      setGateList([]);
      setLoading(true);
      const timeOut = setTimeout(() => fetchGateList(searchKeyword), 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchKeyword]);
  return (
    <Autocomplete
      options={gateList}
      loading={loading}
      getOptionLabel={(option) => (option?.gate_name ? option.gate_name : '')}
      // ค้นหาฝั่ง server แล้ว (ตรงกับ acc_device_id ได้ด้วย) จึงไม่ต้องให้ MUI กรองซ้ำด้วย gate_name
      filterOptions={(options) => options}
      renderInput={(params) => (
        <TextField {...params} label="ประตู" required={required} placeholder="ประตู" />
      )}
      onChange={(_, value) => onChange && onChange(value ? value.id : null)}
      value={selectedValue}
      onInputChange={(_, newInputValue, reason) => {
        // reason 'reset' คือ MUI ใส่ชื่อของตัวที่เลือกลงช่อง input เอง ไม่ต้องค้นหาใหม่
        if (reason === 'reset') return;
        setSearchKeyword(newInputValue);
      }}
      isOptionEqualToValue={(option, v) => v?.id == option?.id}
      fullWidth
    />
  );
};

export default GateFromInput;
